export const ATTENTION_QUERY_KEY = 'attention';

/**
 * Korzeń modułu spraw. Klucz spraw wyjazdu celowo NIE siedzi tutaj, tylko pod
 * `['tours', tourId, 'attention']` — hooki `tourConfig` zmiatają `['tours', tourId]`
 * prefiksowo i mają zabierać sprawy ze sobą.
 */
export const attentionApiQueryKeys = {
  all: () => [ATTENTION_QUERY_KEY] as const,
  company: () => [ATTENTION_QUERY_KEY, 'company'] as const,
};
